import React, { useEffect, useState, useRef } from "react";
import {
  FaPause,
  FaPlay,
  FaPlayCircle,
  FaRegPauseCircle,
  FaSpeakerDeck,
  FaStop,
  FaStopCircle,
  FaVolumeMute,
  FaVolumeOff,
  FaVolumeUp,
} from "react-icons/fa";
import "./TextToSpeech.css";
import { SpeakerIcon } from "lucide-react";

const TextToSpeech = ({
  text = "Hey there! Welcome back 💖 Let's explore this article together!",
  rate = 1,
  pitch = 1.1,
  autoStart = false,
  langPref = "en", // "en" | "marathi"
}) => {
  const [voices, setVoices] = useState([]);
  const [isSpeaking, setIsSpeaking] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const synthRef = useRef(window.speechSynthesis);
  const utteranceRef = useRef(null);

  // 🔹 Load all voices once on mount
  useEffect(() => {
    const loadVoices = () => setVoices(synthRef.current.getVoices());
    loadVoices();

    if (speechSynthesis.onvoiceschanged !== undefined) {
      speechSynthesis.onvoiceschanged = loadVoices;
    }
  }, []);

  // 🔹 Preferred Voice Selector 
    const getPreferredVoice = (voices) => {
        if (!voices.length) return null; 
        if (langPref === "Marathi") {
            return (voices.find((v) => /Marathi|Marathi|मराठी|Google हिन्दी|Hindi|हिन्दी/i.test(v.name)));
        }
        if (langPref === "en") {
            return (voices.find((v) => /Microsoft Brian|Microsoft Prabhat|Microsoft Ravi|Microsoft Maisie|Microsoft Heera/i.test(v.name)) || voices.find((v) => /en-IN|en-GB|en-US/i.test(v.lang)) || voices[0]);
        }
        return voices.find((v) => /India/i.test(v.lang)) || voices[0];
};

  // 🔹 Initialize utterance once voices are loaded
  useEffect(() => {
    if (!voices.length || !text) return;

    const utterance = new SpeechSynthesisUtterance(text);
    utterance.rate = rate;
    utterance.pitch = pitch;
    utterance.voice = getPreferredVoice(voices);

    utterance.onstart = () => setIsSpeaking(true);
    utterance.onend = () => {
      setIsSpeaking(false);
      setIsPaused(false);
    };

    utteranceRef.current = utterance;
  }, [voices, text, rate, pitch, langPref]);

  // 🔹 Control Functions
  const handlePlayPause = () => {
    if (!utteranceRef.current) return;

    if (!isSpeaking && !isPaused) {
        // handle user msg in case of voice contains हिन्दी because it is not supported in some browsers
        synthRef.current.cancel();
        synthRef.current.speak(utteranceRef.current);
        if (!window.speechSynthesis.speaking) {
           console.log("Currently speaking...");
           if(utteranceRef.current.voice && /Hindi|हिन्दी|Google हिन्दी/i.test(utteranceRef.current.voice.name)){
               alert("Note: voice for Hindi/Marathi may not be supported in some browsers. If you don't hear any speech, please try use a different browser.");
           }
        }
      return;
    }

    if (isPaused) {
      synthRef.current.resume();
      setIsPaused(false);
    } else {
      synthRef.current.pause();
      setIsPaused(true);
    }
  };

  const handleStop = () => {
    synthRef.current.cancel();
    setIsSpeaking(false);
    setIsPaused(false);
  };

  // 🔹 Auto Start (optional)
  useEffect(() => {
    if (autoStart && voices.length > 0) {
      const timer = setTimeout(() => {
        handlePlayPause();
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [autoStart, voices]);

  // 🔹 Stop speech when leaving page
  useEffect(() => {
    const stopSpeech = () => synthRef.current.cancel();
    window.addEventListener("beforeunload", stopSpeech);
    window.addEventListener("pagehide", stopSpeech);
    return () => {
      stopSpeech();
      window.removeEventListener("beforeunload", stopSpeech);
      window.removeEventListener("pagehide", stopSpeech);
    };
  }, []);

  return (
    <div
      className="speach-container border"
    >
      {/* 🎧 Play / Pause Button */}
      <button
        onClick={handlePlayPause}
        className={`btn btn-sm ${
          isPaused ? "btn-success" : "btn-primary"
        }`}
        style={
          { color: "violet"}
        }
        title={isPaused ? "Resume" : isSpeaking ? "Pause" : "Play"}
      >
        {isPaused ? <FaVolumeMute className="text-info animate-volume" /> : isSpeaking ? <FaVolumeUp className="text-info animate-volume" />  : <FaVolumeMute className="text-info animate-volume" />}
      </button>

      {/* ⏹ Stop Button
      {isSpeaking && (
        <button
          onClick={handleStop}
          className="btn btn-sm btn-danger"
          title="Stop"
        >
          <FaStop />
        </button>
      )} */}

      {/* 🔊 Voice Animation */}
      {/* {isSpeaking  && (
       <button className="btn" disabled> <FaVolumeUp className="text-info animate-volume" /></button>
      )} */}

     
    </div>
  );
};

export default TextToSpeech;
